import { Controller } from "@hotwired/stimulus"
import { events } from "../../utils/events"
import PresenceValidator from "../../validators/presence_validator"

export default class extends Controller {
  connect() {
    this.element.addEventListener('submit', e => this.validateAll(e))
    this.errors = {}
    this.eventTypeFor = events
    this.#bindInputs()
  }

  validateAll(event) {
    this.element.querySelectorAll('select').forEach(input => this.#validate({ currentTarget: input }))
    this.element.querySelectorAll('input').forEach(input => this.#validate({ currentTarget: input }))

    if (!this.#validForm()) {
      event.preventDefault()
      event.stopPropagation()
      const submit = document.querySelector('button[form="validation-form"]')
      if (submit) submit.disabled = false
    } else {
      this.element.requestSubmit()
    }
  }

  #validForm() {
    const valid = Object.values(this.errors).some(value => value.valid === false)
    return !valid
  }

  #bindInputs() {
    this.element.querySelectorAll('select').forEach(element => {
      this.#bindValidation(element)
    })
    this.element.querySelectorAll('input').forEach(element => this.#bindValidation(element))
  }

  #bindValidation(element) {
    if(element.type === 'hidden') return

    element.addEventListener(this.eventTypeFor[`${element.type}`], e => this.#validate(e))
  }

  #validate(event) {
    const input = event.currentTarget
    let inputValue = ''
    if(input.type === 'hidden') return false

    if (input.type === 'radio' || input.type === 'checkbox') {
      const nodes = Array.from(input.closest('fieldset').querySelectorAll(`input[type=${input.type}]`))
      inputValue = nodes.some(n => n.checked) ? input.value : ''

    } else {
      inputValue = input.value
    }
    const validator = new PresenceValidator(inputValue, {}, { invalid: 'Campo requerido' }, input.id, true)
    let validationResult = validator.validate()
    this.errors[input.id] = validationResult
    this.render(input, validationResult)
  }

  render(target, validation) {
    if (!validation.valid) {
      this.renderValidation(target, { result: { message: 'Campo requerido' } })
    } else {
      this.clearValidation(target, {})
    }
  }

  clearValidation(target, _validator) {
    target.classList.remove('invalid')

    const help = target.closest('fieldset').querySelector('.error-label')
    help.classList.remove('show')
    help.innerHTML = ''
  }

  renderValidation(target, validator) {
    target.classList.add('invalid')
    const help = target.closest('fieldset').querySelector('.error-label')
    help.classList.add('show')
    help.innerHTML = `${validator.result.message}<br>`
  }
}
